import React from 'react';
import { RolloverConstants } from '../../../RolloverConstants';
import {
  SSJBeaconButton,
  SSJBeaconModal,
} from '../../../../Shared/Beacon/Registry';
import { useSelector } from 'react-redux';
import downloadIcon from '../../../../../assets/images/download-icon.svg';
import retirementIcon from '../../../../../assets/images/retirement-icon.svg';
import { callPdfGeneration, getEndpoint } from '../../../../../utils/api';
import printIcon from '../../../../../assets/images/print-icon.svg';
import TRP from '../../../../Shared/TRP/TRP';
import config from '../../../../../config/config';
import { getPersonalInformationData } from '../../../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import { pdfGeneration } from '../../../../../utils/fundingMethod/fundingMethodUtils';

export function Indirect() {
  const fundingTrackingData = useSelector(
    (state) =>
      state?.fundingTrackingData?.payload?.onboardingDataStore
        ?.onboardingDatastoreRollover
  );
  const fundingTrackingStore = useSelector(
    (state) => state?.fundingTrackingData?.store
  );
  const userInformation = useSelector(getPersonalInformationData);

  const handleModalClick = (action) => {
    const modal = document.querySelector('#downloadInvesTryAgian');
    if (modal === null) {
      return;
    }
    //
    switch (action) {
      case 'TryAgain':
        modal.show();
        break;
      case 'Cancel':
        modal.close();
        break;
      default:
        break;
    }
  };

  const downloadCheck = async () => {
    const investmentSlipPayload = {
      accountType: fundingTrackingStore?.userAccountFundingData?.agreementType,
      customer: {
        firstName: userInformation?.firstName,
        middleName: userInformation?.middleName,
        lastName: userInformation?.lastName,
      },
      address: {
        street1: fundingTrackingStore?.userAccountFundingData?.address.street1,
        city: fundingTrackingStore?.userAccountFundingData?.address.city,
        state: fundingTrackingStore?.userAccountFundingData?.address.state,
        zip: fundingTrackingStore?.userAccountFundingData?.address.zip,
      },
      fundSelections: [
        {
          dollarAmount: fundingTrackingData?.rolloverAmount,
          fundName: fundingTrackingStore?.userAccountFundingData?.fundName,
          accountNumber: fundingTrackingStore?.AccountAgreementNumber,
        },
      ],
    };
    //
    try {
      const pdfResponse = await callPdfGeneration(
        getEndpoint('mailCheck'),
        { method: 'POST' },
        JSON.stringify(investmentSlipPayload)
      );
      pdfGeneration(pdfResponse);
    } catch (err) {
      console.log('Error:', err);
      handleModalClick('TryAgain');
    }
  };

  return (
    <div id="rollover-guide-container" className="rollover-guide">
      <div className="page-header">
        <div className="title">
          {RolloverConstants.rolloverGuidePage.indirect.title}
          <div className="nextStep-wrapper_header_print">
            <SSJBeaconButton
              id="printButton"
              label="Print"
              variant="tertiary"
              icon-align="left"
              onClick={() => {
                window.print();
              }}
            >
              <img
                slot="icon"
                icon-align="left"
                alt="Print Button"
                fill="none"
                className="nextStep-wrapper_header_print_icon"
                height="18"
                width="18"
                src={printIcon}
              />
            </SSJBeaconButton>
          </div>
        </div>
        <div className="description">
          <p>
            To complete your rollover, contact{' '}
            {fundingTrackingData?.externalFinancialInstituteName} and tell them
            you'd like to initiate a rollover to your <TRP /> IRA.
          </p>
          <p>
            Tip: Mail your rollover check to <TRP /> within 60 days of receiving
            it from {fundingTrackingData?.externalFinancialInstituteName}
          </p>
        </div>
      </div>
      <div className="page-body">
        <div className="instruction print-investment">
          <div className="number-icon">
            <div className="circle">1</div>
          </div>
          <div className="details">
            <div className="title">Print your Investment Slip</div>
            <div className="sub-title">
              <span>{`${fundingTrackingStore?.normalizedAccountType}`}</span>
            </div>
            <div className="sub-description investment-slip-info blocked_data">
              {fundingTrackingData?.rolloverToAccountNumber}
              <span className="dot" />
              {`${fundingTrackingStore?.userAccountFundingData?.agreementParties[0]?.fullName}`}
            </div>
            <SSJBeaconButton
              id="detials-submit-btn"
              className="submit-btn"
              label="Download Investment Slip"
              variant="primary"
              icon-align="left"
              onClick={downloadCheck}
            >
              <img
                slot="icon"
                icon-align="left"
                alt="Download Slip Button"
                className="continue-arrow-icon"
                fill="none"
                height="16"
                width="16"
                src={downloadIcon}
              />
            </SSJBeaconButton>
          </div>
        </div>
        <div className="line-thin" />
        <div className="instruction mail-check">
          <div className="number-icon">
            <div className="circle">2</div>
          </div>
          <div className="details">
            <div className="title">
              Ask that the check and any documents be mailed to:
            </div>
            <div className="sub-description">
              <div className="section-1">
                <p>
                  <TRP /> Account Services
                </p>
                <p>PO Box 17300</p>
                <p>Baltimore, MD 21297-1300</p>
              </div>
              <div className="section-2">
                <label className="sub-title">For Overnight:</label>
                <p>
                  <TRP /> Account Services
                </p>
                <p>Mail Code 17300</p>
                <p>4515 Painters Mill Rd.</p>
                <p>Owings Mills, MD 21117-4903</p>
              </div>
            </div>
          </div>
        </div>
        <div className="line-thin" />
        <div className="instruction whats-next">
          <div className="retirement-icon">
            <img src={retirementIcon} alt="retirement-icon" />
          </div>
          <div className="details">
            <div className="title"> What's next?</div>
            <div className="sub-description">
              {RolloverConstants.rolloverGuidePage.indirect.whatsNext}
            </div>
          </div>
        </div>
        <div className="line-thin" />
        <SSJBeaconButton
          id="detials-submit-btn"
          className="submit-btn"
          label="Go to My Account Dashboard   >"
          variant="secondary"
          onClick={() =>
            (window.location.href = `${config.url}/${RolloverConstants.rolloverFunding.link.accountDashboardDev}`)
          }
        />
      </div>
      <div className="line-thin" />
      <SSJBeaconModal
        id="downloadInvesTryAgian"
        scale="normal"
        elevation="3"
        closeonclickout=""
      >
        <p className="beacon-modal__title">Something went wrong</p>
        <p className="beacon-modal__description">
          {`There was an issue generating your investment slip but your information is not lost. Please try again. If the problem persists, you can call a service specialist at (855) 793-6611.`}
        </p>
        <div className="download-invest-try-again">
          <div className="download-invest-try-again_container">
            <SSJBeaconButton
              id="saveButton"
              type="button"
              variant="tertiary"
              onClick={() => handleModalClick('Cancel')}
              label="Cancel"
            />
            <SSJBeaconButton
              id="exitButton"
              type="button"
              variant="negative"
              onClick={downloadCheck}
              label="Try again"
            />
          </div>
        </div>
      </SSJBeaconModal>
    </div>
  );
}
